// extracted by mini-css-extract-plugin
export var container = "_nn-0";
export var dotAnimation = "_nn-2";
export var dotsLoading = "_nn-1";